<script>
export default {
  name: "UploadedNotesView",

  props: {
    fileNotes: {
      type: Array,
      required: true,
      default: () => [],
    },
    showModal: Boolean,
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="w-11/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Notes</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div class="w-full" v-for="(image, idx) in fileNotes" :key="idx">
          <h5 class="text-sm font-bold">{{ image.comment }}</h5>
          <img
            :src="`data:application/image;base64,${image.investigationImage}`"
          />
          <iframe :src="`data:application/pdf;base64,${image.investigationImage}`" 
          height="800" width="1200"></iframe>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click="$emit(`closeModal`)"
      >
        Close
      </button>
    </template>
  </tail-modal>
</template>
